import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("meta", {
  name: "viewport",
  content: "width=device-width, initial-scale=1"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("meta", {
  name: "mobile-web-app-capable",
  content: "yes"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("meta", {
  name: "apple-mobile-web-app-capable",
  content: "yes"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_router_view),
    _createVNode(_component_Toast, { position: "top-right" })
  ]))
}